import { pathname as SectionPathname } from "~/pages/section/index";
// This is to avoid missing query parameters from a base link for the app bar when redirecting with client route push, e.g. appBarVariant."
export const shouldRedirectBaseDynamicSectionLink = (
  pathName: string,
  query?: Record<string, string | undefined>,
) => {
  if (query?.appBarVariant) return false;
  return pathName === SectionPathname;
};
